// Shared admin-ajax helpers. Resolves the correct admin-ajax URL on this
// Bedrock install (WP lives at /wp/) and wraps the common nonce-bearing POST.

export function getAjaxUrl() {
    if (window.zd_ajax_object && window.zd_ajax_object.ajax_url) {
        return window.zd_ajax_object.ajax_url;
    }
    if (window.ajaxurl) return window.ajaxurl;
    return '/wp/wp-admin/admin-ajax.php';
}

export function getNonce() {
    return (window.zd_ajax_object && window.zd_ajax_object.nonce) || '';
}

// jQuery.post wrapper that adds action + nonce automatically.
// Returns the jqXHR so callers can .done/.fail/.always as usual.
export function ajaxPost(action, payload) {
    return jQuery.post(getAjaxUrl(), Object.assign({
        action: action,
        nonce: getNonce(),
    }, payload || {}), null, 'json');
}
